import { createClient } from '@supabase/supabase-js';

// Trim whitespace/newlines from env values. A trailing newline on the anon
// key (from how the Vercel env var was pasted) is harmless for REST headers
// but gets URL-encoded as %0A into the realtime WebSocket apikey param, which
// fails auth ("no valid credentials available") and silently kills ALL
// realtime subscriptions app-wide (live approvals inbox, live chat, etc.).
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || 'https://api.voiceconnector.com').trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

const isBrowser = typeof window !== 'undefined';
const isInIframe = isBrowser && window.self !== window.top;

/* Build auth options and use a distinct storageKey when inside an iframe */
const authOptions: any = {
  persistSession: true,
  autoRefreshToken: true,
  // Required for magic link authentication (email sign-in links)
  detectSessionInUrl: true,
  // Critical: disable cross-tab/session broadcast from iframe so it doesn't update the parent
  // Supabase uses BroadcastChannel/localStorage events when multiTab=true; we turn it off in iframe.
  multiTab: !isInIframe,
};

if (isInIframe) {
  // Use a separate storage bucket so iframe auth does not overwrite parent session
  let host = 'app';
  try {
    host = new URL(supabaseUrl).host;
  } catch {
    // noop
  }
  authOptions.storageKey = `sb-${host}-iframe-auth-token`;
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: authOptions,
});